<template>
  <div class="page" v-wechat-title="$route.meta.title">
    <!--地图-->
    <div class="map-box">
      <div class="amap amap1" id="container"></div>
      <!--<el-amap class="amap" vid="container" id="container" resizeEnable="true"></el-amap>-->

    </div>

    <!--小图标-->

    <div class="map-icons">
      <div class="map-icon">
        <!--<div class="border-box" @click="toComment">-->
          <!--<img src="../../assets/map/icon-pj.png" alt="">-->
          <!--<p>评价</p>-->
        <!--</div>-->
        <!--桂东1678专属，班车列表-->
        <div class="border-box" @click="toMapBus" v-if="shopid==1678">
          <img src="../../assets/map/icon-bc.png" alt="">
          <p>班车</p>
        </div>
        <div class="border-box" @click="callTel">
          <img src="../../assets/map/icon-sos.png" alt="">
          <p>SOS</p>
        </div>
      </div>

      <img class="mygps" src="../../assets/icon_25.png" alt="" @click="getAndPantoLocation()">
    </div>


    <div class="spot1" :class="showList?'active':''">
      <!--语音播放操作栏-->
      <div class="guide border-box" :class="playshow?'active':''" v-if="currIndex>=0">
        <div class="guide-box box" v-if="playshow">
          <div class="guide-img" @click.stop="tabCode='listen',scollToDom('voice-list-p'+voicelist[index1].id,'VoiceScoll')"><img class="img" :src="voicelist[index1].logo" alt=""></div>
          <div class="guide-voice flex">
            <p class="guide-tit hide">当前播放：{{voicelist[index1].spotname}}</p>
            <div class="guide-btn">
              <img class="fl" src="../../assets/icon_11.png" alt="" @click.stop="prevPlay()">
              <img class="fl play" :src="isplay==0?require('../../assets/icon_12.png'):require('../../assets/icon_12_curr.png')" alt="" @click.stop="playVideoClick(index1)">
              <img class="fl" src="../../assets/icon_13.png" alt="" @click.stop="nextPlay()">
            </div>
          </div>
        </div>
        <div class="guide-icon" @click="playshow=!playshow"></div>
      </div>


      <div class="spot-nav" :class="shopid==1678?'large':''">
        <div class="spot-li spot-li1">
            <p class="item" :class="tabCode==item.code?'curr':''" @click="tabClick(item.code)" v-for="(item,index) in tablist" :key="item.id" v-if="item.state==1">
              <img :src="(tabCode==item.code)?item.imgPress:item.imgNor" alt="">{{item.name}}
            </p>
        </div>
        <p class="spot-nav-arr" @click="showList=!showList"></p>
      </div>

      <div class="spot-cont" id="spotCont">
        <!--逛景点-->
        <div class="spot-guide border-box" v-if="tabCode=='spot'">
          <div class="navtab-scoll border-box" id="SpotScoll" style="padding-left: 0;padding-right: 0;">
            <div class="jd-li box border-box" :id="'spotli-scoll'+item.id" :class="currItem&&currItem.id==item.id?'curr':''" v-for="(item,index) in spotlist" :key="index" @click="itemClick(item)" v-if="spotlist && spotlist.length>0">
              <div class="flex left">
                <span class="sub">{{(index+1)<10?('0' + (index+1)):(index+1)}}</span>
                <p class="txt1 hide">{{item.name}}
                  <font v-if="item.hotLevel==1" style="font-size: .24rem;"> (推荐)</font>
                  <font v-if="item.pid=='314066'" style="font-size: .24rem;"> (灯彩)</font>
                </p>
                <p class="txt2"><img src="../../assets/icon_29.png" alt="">{{getDistence(position.lat,position.lng,item.lat,item.lng) | initDistance}}</p>
              </div>
              <div class="right">
                <p class="button" @click.stop="toSpotDesc(item)">详情</p>
                <p class="button" @click.stop="openMap(item)">导航</p>
              </div>
            </div>
            <p class="load-tip" v-else>暂无数据</p>
          </div>
        </div>

        <!--寻线路-->
        <div class="spot-guide border-box" v-if="tabCode=='route'">
          <div class="navtab-scoll border-box" id="XLScoll1" v-if="routDescShow==0">
            <div class="spot-li" v-for="(item,index) in routelist" :key="item.id" @click.stop="routeClick(index)" v-if="routelist && routelist.length>0">
              <div class="spot-li-info spot-li-info1 border-box" :class="(routInd===index)?'curr':''">
                <h3 class="hide">{{item.name}}</h3>
                <p class="hide">景点数量 <span>{{item.count}}</span> 个<font v-if="item.special>0">， 游玩时间 <span>{{item.special}}</span> 小时</font></p>
                <div class="but">
                  <span class="button" @click.stop="routeClick(index),routDescShow=1">查看</span>
                </div>
              </div>
            </div>
            <p class="load-tip" v-else>暂无数据</p>
          </div>

          <div class="route-box" v-if="routDescShow==1">
            <div class="route-back" @click="routDescShow=0"><img src="../../assets/icon-left.png" alt=""> {{routelist[routInd].name}}</div>
            <div class="navtab-scoll border-box" id="RouteScoll" style="padding-left: 0;padding-right: 0;">
              <div class="jd-li box border-box" :id="'routeli-scoll'+item.id" :class="currItem&&currItem.id==item.id?'curr':''" v-for="(item,index) in routeDesclist" :key="index" @click="itemClick(item)" v-if="routeDesclist && routeDesclist.length>0">
                <div class="flex left">
                  <span class="sub">{{(index+1)<10?('0' + (index+1)):(index+1)}}</span>
                  <p class="txt1 hide">{{item.name}} <font v-if="item.hotlevel==1" style="font-size: .24rem;"> (推荐)</font></p>
                  <p class="txt2"><img src="../../assets/icon_29.png" alt="">{{getDistence(position.lat,position.lng,item.lat,item.lng) | initDistance}}</p>
                </div>
                <div class="right">
                  <p class="button" @click.stop="toSpotDesc(item)">详情</p>
                  <p class="button" @click.stop="openMap(item)">导航</p>
                </div>
              </div>
              <p class="load-tip" v-else>暂无数据</p>
            </div>
          </div>

        </div>

        <!--听解说-->
        <div class="spot-guide border-box" v-if="tabCode=='listen'">
          <div class="navtab-scoll border-box" id="VoiceScoll">
            <div class="voice-list">
              <p class="voice-list-p clearfix" :id="'voice-list-p'+item.id" v-for="(item,index) in voicelist" :key="index" :class="currItem&&currItem.id==item.id?'curr':''" @click="playVideoClick(index)">
                <img class="fl" src="../../assets/icon_16.png" alt="" v-if="currIndex==index">
                <span v-else>{{index+1}}.</span>
                {{item.spotname}}
                <font>({{item.totaltime|initTime}}）</font>

                <span class="fr" v-if="currIndex==index&&isplay">{{currTime|initTime}}</span>
                <img class="fr" :src="(index<2||buy==true)?require('../../assets/icon_15.png'):require('../../assets/icon_14.png')" alt="" v-else>
              </p>
            </div>
          </div>
        </div>

        <!--服务点位-->
        <div class="spot-guide border-box" v-if="tabCode!='spot' && tabCode!='route' && tabCode!='listen'">
          <div class="navtab-scoll border-box" id="WCScoll">
            <div class="spot-li" :id="'wcli-scoll'+item.id" v-for="(item,index) in servicelist" :key="index" @click="itemClick(item)" v-if="servicelist && servicelist.length>0">
              <div class="spot-li-info border-box" :class="currItem&&currItem.id==item.id?'curr':''" style="width:100%;">
                <h3 class="hide">{{item.name}}</h3>
                <p class="hide">距离 {{getDistence(position.lat,position.lng,item.lat,item.lng) | initDistance}}
                  <span class="li-tag" v-for="(ite,ind) in (item.tag).split('、')" :key="index" v-if="item.tag && (item.tag).split('、')">
                    <a :href="'tel:' + parseInt(ite.replace(/[^0-9]/ig,''))" v-if="ite && ite.indexOf('联系电话')>-1">{{ite}}</a>
                    <font v-else>{{ite}}</font>
                  </span>
                </p>
                <div class="but">
                  <span class="button" @click.stop="toSviceDesc(item)" v-if="tabCodeList[tabCode].hasNext==1">详情</span>
                  <span class="button" @click.stop="openMap(item)">导航</span>
                </div>
              </div>
            </div>
            <p class="load-tip" v-if="!(servicelist && servicelist.length>0)">暂无数据</p>
          </div>
        </div>

      </div>
    </div>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>

  </div>

</template>

<script>
  import Vue from 'vue';
  window._AMapSecurityConfig = {
    securityJsCode:'89eb2b00868f9e6ac15de6c0e7460d32'
  };

  import {mapIndex, mapShop,mapBagTab,mapBagList,mapSpot, mapBagDetail,mapSearch,mapPolyline, getBagComment, getZan,   mapTabs,mapShopSpot,mapSpotDetail,mapVoice,mapRoutes,mapSiteSpots,mapService,mapServiceDetail } from "@/service/getData";
  import {wxGetPosition,wxShareme,wxOpenMapLocation,playVideo,playDragSlide,wxImgPreview,creatOrder,TimeVideo} from '@/utils/wechat'
  import {setStore, getStore, removeStore, scollLoadMore,GAMPGL,getDistence} from '@/config/mUtils'

  import AlertComment from '../../components/AlertComment'
  import AlertPoster from '../../components/AlertPoster'
  import P400 from '../../components/P400'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  Vue.use(D)

  var Map = null,watchid=null;  //地图对象


  export default {
    data: function() {
      return {
        userInfo: {}, //用户信息
        shopid: this.$route.query.shopid || '', //景区id
        spotid: this.$route.query.spotid || '', //景点id
        listenId: this.$route.query.listenId || '', //需要听解说的景点id
        bagid: this.$route.query.bagid || '', //专辑id
        formGuide: this.$route.query.formGuide || '', //从导游详情页过来

        loadText: '', //暂无数据

        shop: [], //景区详情
        spotlist: [], //景点列表
        wclist: [], //厕所数据
        noWc: false, //查询没有厕所

        tablist: [], //栏目列表
        tabCode: '', //选中的栏目code
        routelist: [], //线路列表
        routInd: 0, //选择的线路下标
        routeDesclist: [], //线路详细
        routDescShow: 0, //是否展示线路详情
        servicelist: [], //服务场所列表
        tabCodeList: {}, //根据code组成的tablist列表

        showList: true, //false不展示列表 true:展示列表
        currItem: null, //当前选中的点位

        currMarkerData: {
          marker: "",
          className: ""
        }, // 记录当前点击的地图点标记

        myInteval: null, //实时定位计时器
        locationMarker: null, //定位点
        pointor: true, //监听设备陀螺仪转动
        inSenic: false, //判断是否在景区
        showInSenicTips: true, //是否提示在景区
        boundsLimit: null, //景区范围围栏
        rectangle: null, //景区范围矩形
        position: getStore("position") || {lat: '', lng: ''},  //手机定位经纬度信息
        markerList: [], //地图上的点标记
        polyline: null, //线路点标记

        currGuide: {}, //选择的导游信息
        voicelist: [], //选择的导游的语音列表
        toastshow: 0, //选中导游弹窗
        buy: true, //选中导游的专辑是否购买

        playshow: false, //是否展开播放操作栏
        currTime: 0, //当前播放音频的实时时间
        isplay: 0, //是否在播放
        currIndex: -1, //正在播放的语音下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex)

        appKey: '',
        appKeyA: '',
        P400: 0, //系统维护中
        getDistence: getDistence, //计算距离

        zoomData: {
          shop_1650: {zooms:[15, 20],zoom:16,dot: 17,},
          shop_1678: {zooms:[10, 16],zoom:11,dot: 12,},
          shop_1737: {zooms:[16, 20],zoom:18,dot: 19,},
        }, //

      };
    },
    created() {

      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
      } else {
        setStore("appKey", {"appKey": ""});
      }

      this.userInfo = getStore("userInfo");
      var self = this;
      if(self.shopid){
        self.$loading.show('获取定位');

        wxGetPosition(function(res){
          self.position = {lat: res.latitude, lng: res.longitude };
          setStore("position", self.position);
          self.getView();
        });
      }
      this.mapTabsFun();
      this.mapRoutesFun();
      this.mapVoiceFun();

    },
    beforeRouteEnter (to, from, next) {
      if(to.query && to.query.listenId){
        to.meta.isBack = to.query.listenId
      }
      next();
    },
    activated () {
      if (this.$route.meta.isBack) {
        this.listenId = this.$route.meta.isBack;

        this.tabClick('listen')
        var ind = this.getIndex(this.voicelist,this.listenId);
        this.playVideoClick(ind)

        this.scollToDom('voice-list-p'+this.voicelist[ind].id,'VoiceScoll')
        this.$route.meta.isBack = ''
      }

    },
    beforeDestroy(){
      if(this.myInteval){
        clearInterval(this.myInteval);
        this.myInteval = null;
      }
    },
    methods: {
      //获取景区详情
      async getView(){
        let res = await mapShopSpot({
          shopid: this.shopid
        });
        if (res.errcode === "00000"){
          this.$loading.hide();
          var shop = res.data.shop;
          shop.lng = parseFloat(shop.lng);
          shop.lat = parseFloat(shop.lat);
          this.shop = shop;
          this.spotlist = res.data.root;

          this.$route.meta.title = shop.name || '地图导览';

          let title = shop.name + ' | 地图导览';
          let desc = '一图在手，说走就走；历史会说话！金牌解说与您共享景区故事~';
          let link = '/map-tour?shopid='+this.shopid + '&appKey=' + this.appKey;
          wxShareme(title, desc, shop.logo, link);

          var self = this;
          GAMPGL('404573c508c5457fdc8040930e2efe6e').then(function (AMap) {
            self.initMap();
          });
        }
      },

      //获取菜单栏
      async mapTabsFun(){
        let res = await mapTabs({
          shopid: this.shopid
        });
        if (res.errcode === "00000"){
          this.tablist = res.data;
          if(res.data.length>0){
            this.tabCode = res.data[0].code;

            res.data.forEach(item => {
              this.tabCodeList[item.code] = item;
            });
          }
        }
      },

      //获取线路
      async mapRoutesFun(){
        let res = await mapRoutes({
          shopid: this.shopid,
          name: this.shopid
        });
        if (res.errcode === "00000"){
          this.routelist = res.data;
        }
      },
      //获取线路详细
      async mapSiteSpotsFun(ind){
        let res = await mapSiteSpots({
          id: this.routelist[ind].id
        });
        if (res.errcode === "00000"){
          this.routeDesclist = res.data;
          this.appendMarker(this.routeDesclist);

        }

        if(this.routelist[ind].img){
          if(this.polyline){
            this.polyline.setMap(null)
          }
          this.polyline = new AMap.ImageLayer({
            url: this.routelist[ind].img,
            bounds: this.boundsLimit,
            map: Map,
            zIndex: 116,
          });
        }

      },
      //服务场所列表
      async mapServiceFun(){
        let res = await mapService({
          shopid: this.shopid,
          code: this.tabCode,
          page:1,
          rows:100
        });
        if (res.errcode === "00000"){
          this.servicelist = res.data.root;
          this.appendMarker(this.servicelist);
        }
      },

      //获取语音列表
      async mapVoiceFun(){
        let res = await mapVoice({
          shopid: this.shopid
        });
        if (res.errcode === "00000"){
          this.voicelist = res.data.voiceList;

        }else {
          this.$loading.hide();
        }
      },

      //点击菜单栏
      tabClick: function (code){
        this.tabCode = code;
        this.showList = true;

        if(code=='spot'){ //景点
          this.appendMarker(this.spotlist);
        }else if(code=='route'){ //线路
          this.mapSiteSpotsFun(this.routInd)
        }else if(code=='listen'){ //解说
          this.appendMarker(this.voicelist);
        }else{
          this.mapServiceFun()
        }
      },
      //点击查看线路详情
      routeClick: function (index){
        this.routInd = index;
        this.mapSiteSpotsFun(index)
      },

      //拿到数组中指定spotid的下标
      getIndex(arr,spotid,type){
        let result;
        if(type == 2){
          if(arr.find(function(x) {return x.id == spotid;}) != undefined) {
            arr.find(function(x,i) {
              if(x.id == spotid){
                result =  i;
              }
            });
            return result;
          }else {
            return 0;
          }
        }else {
          if(arr.find(function(x) {return x.spotid == spotid;}) != undefined) {
            arr.find(function(x,i) {
              if(x.spotid == spotid){
                result =  i;
              }
            });
            return result;
          }else {
            if(type==1){
              return -1;
            }else {
              return 0;
            }
          }
        }
      },

      //初始化地图
      initMap: function() {

        var zoom = this.shop.zoom || (this.zoomData['shop_'+this.shopid] && this.zoomData['shop_'+this.shopid].zoom) || 15;
        var zooms = (this.zoomData['shop_'+this.shopid] && this.zoomData['shop_'+this.shopid].zooms) || [15, 20];
        if(document.body.clientWidth>=1000){
          zoom = zoom+1
        }

        Map = new AMap.Map("container", {
          showBuildingBlock: false,
          zoom: zoom,
          zooms: zooms,//pc端20，移动端19
          expandZoomRange: true,
          center: [this.shop.lng, this.shop.lat],
          resizeEnable: true,
          layers: [new AMap.TileLayer.RoadNet({
            detectRetina: false,
            zIndex: 0
          })],
          features: ['bg', 'road'],
          showLabel: false
        });

        this.appendMarker(this.spotlist);


        var self = this;
//        AMap.plugin(['AMap.Geolocation', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar'],function(){//异步加载插件
          //添加地图范围 + 手绘地图
          var northEast = self.shop.northEast, southWest = self.shop.southWest;
          if(northEast && southWest) {
            var northEast1 = new AMap.LngLat(parseFloat(northEast[0]), parseFloat(northEast[1]));
            var southWest1 = new AMap.LngLat(parseFloat(southWest[0]), parseFloat(southWest[1]));

            self.boundsLimit = new AMap.Bounds(southWest1, northEast1);
            //Map.setLimitBounds(self.boundsLimit);

            // 手绘图
            if (self.shop.mapimg) {
              if(self.shop.mapimg.indexOf(this.shopid)<=-1){
                let imageLayer = [
                  new AMap.TileLayer(),
                  new AMap.ImageLayer({
                    url: self.shop.mapimg,
                    bounds: self.boundsLimit,
                    zooms: [15, 20],
                    zIndex: 115
                  })
                ];
                Map.setLayers(imageLayer);
              }else {
                var url = self.shop.mapimg.split('.png')[0]+'_Gaode/';
                var a = new AMap.TileLayer.Flexible({
                  cacheSize: 30,
                  opacity: 1,
                  zIndex: 5,
                  zooms: zooms,
                  createTile: function(e, a, o, i, n) {
                    var r = document.createElement("img");
                    r.src = "".concat(url, "tiles/").concat(o, "/").concat(e, "_").concat(a, ".png"),
                      r.onload = function() {
                        i(r)
                      },
                      r.onerror = function() {
                        n()
                      }
                  }
                });
                a.setMap(Map)
              }

            }

          }

          Map.on("complete", function() {
            console.log("complete");

            Map.on("dblclick",function(){
              console.log(222)
              Map.zoomIn();
            });
            Map.on("click",function(){
              console.log(2222)
              self.showList = false
            });
//            showMapInfo();

            self.getPosition(1); //定位

            self.myInteval = setInterval(function(){
              self.getPosition(); //定位
            },5000);

            self.deviceRotate();  //监听手机转动
          });


          Map.on('mapmove', showMapInfo);
          Map.on('zoomend', showMapInfo);
          function showMapInfo() {
            var zoom = Map.getZoom(); //获取当前地图级别
            console.log(zoom)
          }

//        });
      },
      //缩小
      changeZoom: function (){
        Map.zoomOut();
      },


      //移动地图中心到指定景点
      moveCenter: function (item,num){
          if(num){
            if(Map.getZoom() != num){
              Map.setZoom(num);
            }

          }else {
            var dot = this.zoomData['shop_'+this.shopid].dot;
            if(Map.getZoom() <= dot){
              Map.setZoom(dot+1);
            }
          }

         Map.setCenter([parseFloat(item.lng),parseFloat(item.lat - 0.0005)]);
      },

      //手动获取定位 + 平移到当前位置
      getAndPantoLocation: function (){
//        this.$loading.show('重新获取定位');
        if(this.position.lng && this.position.lat){
          this.inSenic = this.isInSenic(this.position.lng,this.position.lat);
          if(this.rectangle&&this.inSenic == false){
            this.$toast("抱歉，您不在当前景区");
          }else {
            this.moveCenter(this.position);
          }
          this.addMapControl();
        }else {
          this.$toast('未获取到定位权限，请重启微信后再尝试');
        }
      },
      //获取当前定位
      getPosition: function(type){ //1第一次定位
        let self = this;
        console.log('getPosition');
        wxGetPosition(function(res){
          if(res.latitude == "" && res.longitude == ""){
            if( type == 1){
              self.$toast("抱歉，定位失败");
            }else {
              if(self.myInteval){
                clearInterval(self.myInteval);
                self.myInteval = null;
              }
              console.log("定位失败");
            }
          }else{
            self.position = { lat: res.latitude, lng: res.longitude };
            setStore("position", self.position);

            self.inSenic = self.isInSenic(self.position.lng,self.position.lat);

            //地图对象存在时 更新位置坐标
            if (Map) {
              if (self.rectangle && self.inSenic == false && self.showInSenicTips == true) { //不在景区 && 显示是否在景区的提示
                self.$toast("抱歉，您不在当前景区");
                self.showInSenicTips = false;
              }else {
                self.addMapControl();
              }
              if(type == 1 && self.inSenic){
                self.moveCenter(self.position);
              }

            }
          }
        });
      },
      //添加定位点
      addMapControl: function() {
        try {
          if (this.isMarkLocation()) {
            this.locationMarker.setPosition([parseFloat(this.position.lng), parseFloat(this.position.lat)]);
          } else {
            let icon = require('../../assets/icon_24_ind.png');
            this.locationMarker = new AMap.Marker({
              content: '<img  style="transform: translateX(-50%) rotate(0deg);" src="' + icon + '" id="guide-now" class="guide-now"/>',
              offset: new AMap.Pixel(0, 0),
              zIndex: 121,
              position: [parseFloat(this.position.lng), parseFloat(this.position.lat)],
              map: Map
            });
            this.locationMarker.type = "local";

            setmarkeroffset();
            Map.on("zoomchange", function(e){
              setmarkeroffset();
            });
            // 高德缩放地图时  覆盖物标记会偏移，因此处理下偏移量
            let self = this;
            function setmarkeroffset() {
              let maxZoom = Map.getZooms()[1] || 20;
              let zoom = Map.getZoom();
              let c = maxZoom - zoom;
              if (c < 5) {
                self.locationMarker.setOffset(new AMap.Pixel(c * 10, c * 10));
              } else {
                self.locationMarker.setOffset(new AMap.Pixel(4 * 10, 4 * 10));
              }
            }
          }
        } catch (e) {
          console.log("添加定位点失败:", e);
        }
      },
      //判断是否在景区
      isInSenic: function(lng,lat) {
        if(this.rectangle){
          let isInSenic = this.rectangle.contains([parseFloat(lng),parseFloat(lat)]);
          return isInSenic;
        }
      },
      // 判断当前地图上是否存在定位点
      isMarkLocation: function() {
        if (Map) {
          let markers = Map.getAllOverlays();
          for (let i = 0, len = markers.length; i < len; i++) {
            if (markers[i].type && markers[i].type === "local") {
              return true;
            }
          }
          return false;
        }
      },
      // 监听设备陀螺仪转动
      deviceRotate: function() {
        let self = this;
        let ua = navigator.userAgent.toLowerCase();
        if (window.DeviceOrientationEvent) {
          if (/android/.test(ua)) {
            window.addEventListener("deviceorientationabsolute",function(){
              let rote = Math.round(360 - event.alpha);
              rotefun(rote);
            })
          } else {
            if (typeof DeviceOrientationEvent.requestPermission === "function") {
              DeviceOrientationEvent.requestPermission().then(function(permissionState){
                if (permissionState === "granted") {
                  console.log("已授权");
                  // 已经授权成功时，直接监听，否则请求授权
                  window.addEventListener("deviceorientation", function(){
                    let rote = event.webkitCompassHeading;
                    rotefun(rote);
                  },false);
                } else {
                  console.log("已拒绝");
                  self.$toast("您已拒绝方向访问，请清除浏览器缓存再试");
                  self.pointor = false;
                }
              }).catch(function(){
                console.log("未授权");
                // 如果未授权则需要 进行授权
                self.$confirm({
                  title: '提示',
                  content: '需要授权访问设备方向，请点击确认以使用地图功能',
                  component: wxConfirm
                }).then(function(res){
                  if(res == 'success') {
                    DeviceOrientationEvent.requestPermission().then(function(permissionState){
                      console.log(permissionState);
                      if (permissionState === "granted") {
                        window.addEventListener("deviceorientation", function(){
                          let rote = event.webkitCompassHeading;
                          rotefun(rote);
                        }, false);
                      } else {
                        self.$toast("您已拒绝方向访问，请清除浏览器缓存再试");
                        self.pointor = false;
                      }
                    });
                  }
                })
              });
            } else {
              console.log(`该设备不支持方向获取`);
              self.pointor = false;
            }
          }
        }

        function rotefun(rote){
          let markderDom = document.getElementById("guide-now");
          if (markderDom) {
            markderDom.style.transform = 'translateX(-50%) rotate('+ rote +'deg)';
            //存储上一次的角度信息
            window.locationRotate = rote;
          }
        }
      },

      //清除地图点标记
      clearMap: function() {
        if(this.markerList.length > 0){
          Map.remove(this.markerList);
          this.markerList = [];
          this.polyline && this.polyline.setMap();
        }
      },
      //添加点标记
      appendMarker: function (list){
        var type = this.tabCode;

        /*
        if(this.markerList.length > 0 && this.markerList[0].type && this.markerList[0].type == type){
          return false;
        }
        */
        this.clearMap(type);
        let self = this;
        if (list && list.length > 0) {
          list.forEach(function(data,index) {
            let lng, lat, markerIcon, activeClass;
            let name = (type=='listen')?data.spotname:data.name;
            let markerId = data.id;
            let zIndex = 100;

            lng = parseFloat(data.lng);
            lat = parseFloat(data.lat);

            var type1 = type;
            if((type=='spot' || type=='route') && data.pid=='314066'){
              type1 = 'light';
            }else if(type=='spot' && data.hotLevel==1){
              type1 = 'spot1';
            }else if(type=='route' && data.hotlevel==1){
              type1 = 'route1';
            }

            markerIcon = self.tabCodeList[type1].imgMap;
            activeClass = (self.currItem && self.currItem.id) == markerId ? ' active' : ''; // 是否当前选中的景点
            zIndex = (self.currItem && self.currItem.id) == markerId ? 105 : 100;

            if (!lng || !lat) {
              return false;
            }

            let markerContent = '<div class="mapMarker mapMarkerId' + markerId + ' ' + type1 + ' ' + activeClass + '" id="mapMarkerId' + markerId + '"> ' +
              '<div class="mapMarker-img">' +
              '<img src="' + markerIcon + '" alt="' + name + '" />' +
              '</div> ' +
              '<p class="mapMarker-name">' + name + '</p> ' +
              '</div>';

            let marker = new AMap.Marker({
              position: [lng, lat],
              content: markerContent,
              offset: new AMap.Pixel(0, 0),
              zIndex: zIndex,
              map: Map
            });
            // 设置标记点数据
            marker.selfData = data;
            marker.type = type;
            self.markerList.push(marker);

//            if(type=='route' && index==0){
//              self.moveCenter(data,17);
//            }

            marker.on("click", function (e) {
              let selfData = e.target.selfData;
              self.currItem = selfData;
              let className = '.mapMarkerId' + selfData.id;
              self.onMarkerUpdate(marker, className);
              self.showList = true;

              var calss1 = '', calss2 = '';
              if (type == 'spot') { //景点
                calss1 = 'spotli-scoll';
                calss2 = 'SpotScoll';
              } else if (type == 'route') { //线路点位
                calss1 = 'routeli-scoll';
                calss2 = 'RouteScoll';
                self.routDescShow = 1;
              } else if (type == 'listen') {  //解说点位
                calss1 = 'voice-list-p'
                calss2 = 'VoiceScoll'
                var ind = self.getIndex(self.voicelist,selfData.spotid);
                self.playVideoClick(ind)
              } else {
                calss1 = 'wcli-scoll';
                calss2 = 'WCScoll';
              }
              self.scollToDom(calss1 + selfData.id, calss2);

            });
          });

          if(type!='spot' && type!='route' && type!='spot' && type!='listen'){
//          if(type!='spot' && type!='spot' && type!='listen'){
//            Map.setFitView(self.markerList)
          }

        }
      },
      //地图标记点击后的通用逻辑处理
      onMarkerUpdate: function(marker,className) {
        this.clearAllSelect(); // 主动移除地图上相关标记点状态
        // 若 旧的记录的标记点存在时，先移除其选中状态
        if (this.currMarkerData.className) {
          let curel = document.querySelector(this.currMarkerData.className);
          if (curel) {
            this.removeClass(curel, "active");
          }
        }
        this.currMarkerData.className = className; // 设置当前点击的标记点元素

        // 点击时切换选中
        let el = document.querySelector(className);
        if(el){
          this.addClass(el, "active");
        }

        // 将当前选中的标记层级设置靠前
        if (this.currMarkerData.marker) {
          this.currMarkerData.marker.setzIndex(100);
        }
        marker.setzIndex(105);
        this.currMarkerData.marker = marker;
      },
      //清除地图上点的选中样式
      clearAllSelect: function() {
        let self = this;
        let markerDom = document.querySelectorAll(".amap-marker .active");
        if (markerDom.length) {
          markerDom.forEach(function(item){
            self.removeClass(item, "active");
          })
        }
      },
      removeClass: function(obj, cls) {
        if (this.hasClass(obj, cls)) {
          var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
          obj.className = obj.className.replace(reg, " ");
        }
      },
      hasClass: function(obj, cls) {
        return obj.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
      },
      addClass: function(obj, cls) {
        if (!this.hasClass(obj, cls)) obj.className += " " + cls;
      },

      //页面滑动到指定标签id位置
      scollToDom(elmid,boxid){
        let self = this;
        self.$nextTick(function(){
          setTimeout(function(){
            if(document.getElementById(elmid)){
              document.getElementById(boxid).scrollTo(0,parseInt(document.getElementById(elmid).offsetTop-document.getElementById(boxid).offsetTop-40));
            }
          },500)
        })
      },

      //打开地图
      openMap: function (item){
        wxOpenMapLocation(item.lat, item.lng, item.name);
      },
      //拨打电话
      callTel: function (){
        var tel = this.shop.consulttel
        this.$confirm({
          title: '游客您好',
          content: this.shop.name+'客服热线 <br/> <b style="color: #ff7328;">'+ tel +'</b> ',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            window.location.href = 'tel:'+tel;
          }
        })
      },
      //跳转到班车时刻表页面
      toMapBus: function (){
        this.$router.push({
          path: `/map-bus?${'shopid='+this.shopid}`
        });
      },
      //跳转到评价页面
      toComment: function (){
        this.$router.push({
          path: `/map-comment?${'shopid='+this.shopid}`
        });
      },
      //跳转到景点详情
      toSpotDesc: function (item){
        this.$router.push({
          path: `/map-desc?${'spotid='+ item.id+'&shopid='+this.shopid}`
        });
      },
      //跳转到景点详情
      toSviceDesc: function (item){
        this.$router.push({
          path: `/map-desc?${'serviceid='+ item.id+'&shopid='+this.shopid}`
        });
      },
      //点击数据某一项
      itemClick: function (item){
        this.currItem = item;
        if(this.markerList.length) {
          var mark = null;
          for (var i = 0; i < this.markerList.length; i++) {
            if(this.markerList[i].selfData.id == item.id ){
              mark = this.markerList[i]
            }
          }
          if(mark) {
            var className = '.mapMarkerId' + mark.selfData.id;
            this.onMarkerUpdate(mark, className);
            this.moveCenter(item)
          }
        }
      },

      //点击语音收听
      playVideoClick(index){
        playVideo(this,index);

        this.itemClick(this.voicelist[index])
      },

      //点击上一曲
      prevPlay(){
        let currIndex = this.currIndex == 0 ? (this.voicelist.length -1) : (parseInt(this.currIndex) - 1);
        this.playVideoClick(currIndex);
      },
      //点击下一曲
      nextPlay(){
        let currIndex = (this.currIndex == this.voicelist.length -1) ? 0 : (parseInt(this.currIndex) + 1);
        this.playVideoClick(currIndex);
      },

      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      },
    },
    watch:  {

    },
    components: {
      AlertComment,
      AlertPoster,
      P400
    },
    //格式化数据
    filters: {
      //格式化距离
      initDistance: function (num) {
        if(isNaN(num)){
          num = '未知'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'km'
        }else {
          num = num+'m'
        }
        return num;
      },
      //格式化数字
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      //格式化时间
      initTime: function (time) {
        let minute = parseInt(time / 60);
        let second = parseInt(time % 60);
        minute = minute >= 10 ? minute : "0" + minute;
        second = second >= 10 ? second : "0" + second;
        return minute + ":" + second;
      },
    },
    directives: {
      focus: {
        inserted: function (el) {
          el.focus()
        }
      }
    }
  }

</script>

<style>
  .amap-logo,.amap-copyright{ display: none!important; }
  .map-box .amap{position:absolute;left:0;top:0;width:100%;height:100%}
  .amap  .guide-now{position:relative; width:.41rem!important;height:.53rem!important; }
  .amap .mapMarker{position:relative;display:block; width:.49rem;height:.58rem;transform: translate(-50%,-100%);}
  .amap .mapMarker-img{ display:block; width:.49rem;height:.58rem; }
  .amap .mapMarker-img img{width:100%;height:100%; }
  .amap .mapMarker .mapMarker-name{ position: absolute; bottom: -.45rem; left: 50%;transform: translateX(-50%); white-space: nowrap; padding: .03rem .1rem; font-size: .24rem; color: #faaf39; border: .01rem solid #faaf39; border-radius: .05rem; background-color: #fff; }
  .amap .mapMarker.active .mapMarker-name{ color: #fff; background-color: #faaf39; }

  .amap1 .mapMarker.listen .mapMarker-name{  border: .01rem solid #f39c12; color: #f39c12; }
  .amap1 .mapMarker.listen.active .mapMarker-name{ color: #fff; background-color: #f39c12; }
  .amap1 .mapMarker.spot .mapMarker-name{  border: .01rem solid #00a65a; color: #00a65a; }
  .amap1 .mapMarker.spot.active .mapMarker-name{ color: #fff; background-color: #00a65a; }
  .amap1 .mapMarker.spot1 .mapMarker-name{  border: .01rem solid #dd4b39; color: #dd4b39; }
  .amap1 .mapMarker.spot1.active .mapMarker-name{ color: #fff; background-color: #dd4b39; }
  .amap1 .mapMarker.light .mapMarker-name{  border: .01rem solid #dd4b39; color: #dd4b39; }
  .amap1 .mapMarker.light.active .mapMarker-name{ color: #fff; background-color: #dd4b39; }
  .amap1 .mapMarker.route1 .mapMarker-name{  border: .01rem solid #dd4b39; color: #dd4b39; }
  .amap1 .mapMarker.route1.active .mapMarker-name{ color: #fff; background-color: #dd4b39; }
  .amap1 .mapMarker.route .mapMarker-name{  border: .01rem solid #00a6a0; color: #00a6a0; }
  .amap1 .mapMarker.route.active .mapMarker-name{ color: #fff; background-color: #00a6a0; }
  .amap1 .mapMarker.wc .mapMarker-name{  border: .01rem solid #35a1f5; color: #35a1f5; }
  .amap1 .mapMarker.wc.active .mapMarker-name{ color: #fff; background-color: #35a1f5; }
  .amap1 .mapMarker.sale .mapMarker-name{  border: .01rem solid #00a6a0; color: #00a6a0; }
  .amap1 .mapMarker.sale.active .mapMarker-name{ color: #fff; background-color: #00a6a0; }
  .amap1 .mapMarker.point .mapMarker-name{  border: .01rem solid #00a65a; color: #00a65a; }
  .amap1 .mapMarker.point.active .mapMarker-name{ color: #fff; background-color: #00a65a; }
  .amap1 .mapMarker.stop .mapMarker-name{  border: .01rem solid #2278c6; color: #2278c6; }
  .amap1 .mapMarker.stop.active .mapMarker-name{ color: #fff; background-color: #2278c6; }
  .amap1 .mapMarker.food .mapMarker-name{  border: .01rem solid #faaf39; color: #faaf39; }
  .amap1 .mapMarker.food.active .mapMarker-name{ color: #fff; background-color: #faaf39; }
  .amap1 .mapMarker.hotel .mapMarker-name{  border: .01rem solid #605ca8; color: #605ca8; }
  .amap1 .mapMarker.hotel.active .mapMarker-name{ color: #fff; background-color: #605ca8; }


</style>

<style scoped>
  .page{position: fixed; left: 0; top: 0; right: 0;bottom: 0; padding-bottom: 0; width: 100%; height: 100%; }
  /*地图*/
  .map-box{ position: relative; z-index: 1; width: 100vw; height: calc(100vh - 1.06rem);  }


  .load-tip{ padding-right: .25rem;}

  /*小图标*/
  .map-icons{ position: fixed; right: .25rem; top: .4rem; width: .73rem; z-index: 2; }
  .mygps{ margin-top: .25rem; margin-left: -.05rem; width: .85rem; max-width: .85rem!important; height: .84rem; }
  .map-icon{ padding: 0 .11rem; width: .51rem; background-color: #fff; box-shadow: 0 .03rem .05rem rgba(0,0,0,.2); border-radius: .08rem; }
  .map-icon > .border-box{ display: block; padding: .14rem 0 .1rem; width: .51rem; text-align: center; border-top: .01rem solid #e4e4e4; }
  .map-icon > .border-box:first-child{ border-top: none; }
  .map-icon > .border-box > img{ display: block; margin: 0 auto; width: .36rem; height: auto; }
  .map-icon > .border-box > p{ margin-top: .05rem; font-size: .2rem; color: #000; letter-spacing: .02rem; }

  /*讲解悬浮窗*/
  .flow{ position: relative;left: .27rem;top: .9rem; z-index: 2; width: 2.84rem; height: 1rem; padding:.09rem; box-shadow: 0 .05rem .08rem rgba(0,0,0,.1);background: #fff;border-radius: .1rem; }
  .flow-img{ position: relative; width: .82rem; height: .82rem; border-radius: 50%; overflow: hidden; }
  .flow-img .play{ position: absolute; left: 50%; top: 50%; z-index: 1; width: .34rem; height: .34rem; transform: translate(-50%,-50%); }

  /*导游+景点*/
  .spot1{ position: fixed; left: 0; right: 0; bottom: 0; z-index: 3; background-color: #fff; box-shadow: 0 .05rem .09rem rgba(102,102,102,.1);  }
  .spot1.slideUp{animation:mapSlideUp .6s linear;animation-fill-mode: forwards;  }
  @keyframes mapSlideUp {from{transform: translateY(100%); }to{transform: translateY(0);}}
  @keyframes mapSlideDown {from{transform: translateY(0); }to{transform: translateY(100%);}}
  @keyframes mapSlideDown1 {from{transform: translateY(0); }to{transform: translateY(5.57rem);}}
  .spot1.slideDown{animation:mapSlideDown1 .6s linear;animation-fill-mode: forwards;  }

  .spot-nav{ position: relative; padding: 0 1rem 0 .2rem; border-bottom: .01rem solid #e3e3e3; border-top: .01rem solid #e3e3e3; }
  .spot-nav .spot-li{ padding: .15rem 0;height: .76rem; border-bottom: none; }
  .spot-nav .spot-li-img{width: .84rem; height: .76rem; border-radius: 0; }
  .spot-nav .spot-li-info{ height: .76rem; }
  .spot-nav .spot-li-info > h3{padding-top: .1rem; }
  .spot-nav-list{ display: inline-block; margin-right: .3rem; padding: 0 .2rem; }
  .spot-nav-list .icon{ display: block; margin: 0 auto; width: auto; height: .3rem; }
  .spot-nav-list .txt{ margin-top: .08rem; line-height: .22rem; font-size: .2rem; color: #a0a0a0; text-align: center; }
  .spot-nav-arr{ position: absolute; top: .15rem; right: 0; bottom: .15rem; width: 1rem; border-left: .02rem solid #e3e3e3;background: url(../../assets/sm-icon03-curr.png) no-repeat center; background-size: .32rem auto; }
  .spot1.active .spot-nav-arr{ border-left: .01rem solid #e3e3e3; background: url(../../assets/sm-icon03.png) no-repeat center; background-size: .28rem auto; }


  .spot-cont{ height: 0; overflow: hidden; }
  .spot1.active .spot-cont{ height: auto; }

  /*景点+厕所列表*/
  .navtab-scoll{ padding: 0 .07rem .4rem .25rem; height: 5.6rem; overflow-x: hidden; overflow-y: auto; }
  .spot-li{ padding: .22rem 0; height: .84rem; border-bottom: .01rem solid #f5f5f5; }
  .spot-li-img{ position: relative; margin-right: .15rem; width: .84rem; height: .86rem; border-radius: 100%; overflow: hidden; }
  .spot-li-info{ position: relative; padding-right: 2.7rem; height: .86rem; }
  .spot-li-info > h3{ padding-top: .15rem; font: normal .28rem/.32rem "Microsoft YaHei"; color: #474747; }
  .spot-li-info.curr > h3{ color: #faaf39; font-weight: normal; }
  .spot-li-info > p{ margin-top: .1rem; font: normal .22rem/.24rem "Microsoft YaHei"; color: #a0a0a0; }
  .spot-li-info .but{ position: absolute; right: 0; top: 50%; transform: translateY(-50%); }
  .button{ display: inline-block; margin-right: .2rem; width: 1.06rem; height: .46rem; line-height: .48rem; font-size: .24rem; cursor: pointer; border: .01rem solid #666; color: #666;  text-align: center;  border-radius: .1rem; }

  /*导游列表*/
  .spot-guide{ box-shadow: 0 -.07rem .13rem rgba(231,231,231,.3); border-radius: .08rem .08rem 0 0; }
  .spot-tab{ padding: .2rem 0 .12rem; }
  .spot-tab p{ position: relative; height: .41rem; text-align: center; }
  .spot-tab p span{ display: inline-block; padding: 0 .04rem; height: .36rem; font: bold .26rem/.36rem "Microsoft YaHei"; color: #a4a3a3; border-bottom: .05rem solid transparent; }
  .spot-tab p.curr span{color: #040000; border-bottom: .05rem solid #f9ce17; }
  .spot-scoll{ padding: 0 .25rem; height: 4.77rem; overflow-x: hidden; overflow-y: auto; }
  .scoll-list{ height: auto; width: 100%; overflow-y: auto; overflow-x: hidden; }
  .list-li{ margin-top: .28rem; padding-bottom: .25rem; border-bottom: .01rem solid #f1f1f1; }
  .list-li-img{ position: relative; width: 1.48rem; height: 1.8rem; border-radius: .1rem; overflow: hidden; }
  .list-li-img .gif{ position: absolute; left: 0; right: 0; top: 0; bottom: 0; width: 100%; background-color: rgba(0,0,0,.5); }
  .list-li-img .gif img{ position: absolute; left: 50%; top: 50%; margin: -.11rem 0 0 -.105rem; width: .21rem; height: .22rem; }
  .list-li-info{ position: relative; margin-left: .3rem; height: 1.8rem; }
  .list-li-info .tit{ font-size: .32rem; color: #333; }
  .list-li-info .tit .tag{ vertical-align: text-top; }
  .list-li-info .tag{ display: inline-block; height: .3rem; line-height: .32rem; margin-left: .08rem; padding: 0 .1rem; color: #faaf39; border: .01rem solid #faaf39; font-size: .22rem; border-radius: .05rem;vertical-align: text-bottom; }
  .list-li-info .name{ margin-top: .1rem; line-height: .32rem; font-size: .24rem; color: #555; }
  .list-li-info .label{ position: relative; display: inline-block; height: .3rem; vertical-align: middle; line-height: .32rem; margin: .11rem .25rem 0 0; font-size: .2rem; color: #666; }
  .list-li-info .label img{ position: relative; left: 0; top: 50%; width: .24rem; height: .24rem; -webkit-transform: translateY(-50%); transform: translateY(-50%); }
  .list-li-info .bottom{ position: absolute; left: 0; bottom: 0; width: 100%; }
  .list-li-info .bottom .pri{ color: #faaf39; }
  .list-li-info .bottom .pri span{ font-size: .24rem; color: #666;}
  /*.list-li-info .bottom .btn{ right: .02rem; width: 1.2rem; }*/
  .list-li-info .bottom .button{ position: absolute; right: 0; bottom: -.05rem; width: 1.2rem; }


  /*当前播放语音*/
  .guide{ position: absolute; left: 0; top: -.9rem; z-index: 2; width: 0; height: .9rem; padding: .15rem .4rem .15rem 0; background: linear-gradient(to right ,rgba(255,168,32,.9),rgba(255,194,49,.9)); overflow: hidden; }
  .guide-icon{ position: absolute; right: 0; top: .15rem; width: .4rem; height: .6rem; background: url(../../assets/icon_45.png) no-repeat center; background-size: .3rem auto; }
  .guide.active{ width: 100%; padding-right: .8rem; }
  .guide.active .guide-icon{  width: .8rem; border-left: .01rem solid #fff; background: url(../../assets/icon_46.png) no-repeat center; background-size: .36rem auto; }
  .guide-box{  position: relative; width: 100%; height: .6rem; padding: 0 .2rem; }
  .guide-img{ position: relative; width: .6rem; height: .6rem; overflow: hidden; }
  .guide-voice{ position: relative; padding-left: .25rem; }
  .guide-tit{ font-size: .2rem; color: #fff; }
  .guide-btn{ margin-top: .06rem; }
  .guide-btn img{ display: inline-block; padding-right: .3rem; width: .26rem; height: auto; }
  .guide-btn .play{ padding-right: .35rem; margin-left: .23rem; margin-right: .25rem; }


  /*语音列表*/
  .voice-list{ padding: 0 .05rem; }
  .voice-list-p{ padding: .25rem 0 .25rem; height: .37rem; line-height: .37rem; font-size: .26rem; color: #5d5d5d; border-bottom: .01rem solid #f9f9f9; }
  .voice-list-p font{ font-size: .18rem; color: #e38c0f; }
  .voice-list-p.curr{ color: #ff7328; }
  .voice-list-p img{ display: inline-block; margin-right: .19rem; width: .28rem; height: auto; }
  .voice-list-p img.fl{ margin-right: .15rem; }


  .spot-li1{ width: 100%; overflow-y: hidden; overflow-x: auto;white-space: nowrap;}
  .spot-li .item{display: inline-block; width: 20vw; font-size: .24rem; text-align: center; }
  .spot-li .item.curr{color: #faaf39;}
  .spot-li .item img{ display: block; margin: 0 auto .1rem; width: auto; height: .4rem; }
  /*菜单换行*/
  .spot-nav.large .spot-li1{overflow:hidden;white-space:normal;}
  .spot-nav.large .spot-li1{ padding: 0 0 .1rem;height: 1.76rem;}
  .spot-nav.large .spot-li1 .item{margin-top: .1rem; }
  .spot-nav.large .spot-li .item img{margin-bottom: .08rem; }

  .li-tag{display: inline-block; height: 0.3rem; line-height: .3rem; text-align: center; padding: 0 0.16rem; border: 1px solid #faaf39; border-radius: 0.03rem; margin-left: 0.1rem; font-size: .2rem; color: #faaf39;}
  .li-tag a{color: #faaf39;}

  /*逛景点*/
  .jd-li{ margin-top: .1rem; padding-left: .15rem; background-color: #fefdf3;-webkit-box-align: center;align-items: center;}
  .jd-li .left{position: relative; padding-left: .7rem; overflow: hidden; border-top-left-radius: .1rem;}
  .jd-li .sub{ display: inline-block;position: absolute; left: -0.3rem; top: -0.3rem; width: 0.65rem; height: 0.8rem; line-height: 1rem; text-align: right; background-color: #ffbb50; color: #fff; padding-right: 0.15rem; font-size: .24rem; border-radius: 50%; }
  .jd-li .txt1{ font-size: .28rem; line-height: .42rem; color: #333; }
  .jd-li .txt2{ font-size: .24rem; line-height: .4rem; color: #999; }
  .jd-li .txt2 img{ display: inline-block; margin-right: .06rem; height: .26rem; vertical-align: text-top; }
  .jd-li.curr .txt1{color: #faaf39;font-weight: bold;}

  /*寻线路*/
  .spot-li-info1{padding-right: .2rem;}
  .spot-li-info1.curr > h3{ color: #faaf39; }
  .spot-li-info1.curr .hide span{ color: #faaf39; }
  /*线路详情*/
  .route-box .navtab-scoll{ height: 4.9rem; }
  .route-back{ height: .7rem; line-height: .7rem;font-size: .32rem; color: #333; }
  .route-back img{ margin:.2rem .06rem 0 .16rem; height: .3rem; }



  ::-webkit-scrollbar{width:.66vw;height:.66vw;border:.4vw}
  ::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 .8vw rgba(0,0,0,.3);background-color:transparent;border-radius:.26vw}
  ::-webkit-scrollbar-thumb{border-radius:.93vw;-webkit-box-shadow:inset 0 0 .8vw rgba(0,0,0,.3);background-color:#ccc}
  ::-webkit-scrollbar-button{background-color:none}
  ::-webkit-scrollbar-corner{background:none}

  /* 台式电脑显示器屏幕字体大小 */
  @media screen and (min-width: 1000px) {
    ::-webkit-scrollbar{width:.4vw;height:.4vw;border:.4vw}
  }

</style>




// WEBPACK FOOTER //
// src/page/map/map-tour.vue